var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNumbers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.375 6.625H9.33333C8.1137 6.625 7.125 7.6137 7.125 8.83333V19.875C7.125 21.0946 8.1137 22.0833 9.33333 22.0833H20.375C21.5946 22.0833 22.5833 21.0946 22.5833 19.875V8.83333C22.5833 7.6137 21.5946 6.625 20.375 6.625Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 30.9167H9.33333C8.1137 30.9167 7.125 31.9055 7.125 33.1251V44.1667C7.125 45.3864 8.1137 46.3751 9.33333 46.3751H20.375C21.5946 46.3751 22.5833 45.3864 22.5833 44.1667V33.1251C22.5833 31.9055 21.5946 30.9167 20.375 30.9167Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 6.625H33.625C32.4053 6.625 31.4166 7.6137 31.4166 8.83333V19.875C31.4166 21.0946 32.4053 22.0833 33.625 22.0833H44.6666C45.8863 22.0833 46.875 21.0946 46.875 19.875V8.83333C46.875 7.6137 45.8863 6.625 44.6666 6.625Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 30.9167H33.625C32.4053 30.9167 31.4166 31.9055 31.4166 33.1251V44.1667C31.4166 45.3864 32.4053 46.3751 33.625 46.3751H44.6666C45.8863 46.3751 46.875 45.3864 46.875 44.1667V33.1251C46.875 31.9055 45.8863 30.9167 44.6666 30.9167Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNumbers);
export default __webpack_public_path__ + "static/media/Icon-numbers.5a5d35e44fc63b17859b644d6fb0c170.svg";
export { ForwardRef as ReactComponent };